
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/[url_slug]",
      function () {
        return require("private-next-pages/event/[url_slug]/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/[url_slug]"])
      });
    }
  